import { styled } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ReadingAidsOptionsWrapper = styled.span({
	zIndex: 1,
	right: 0,
	display: 'flex',
	minHeight: token('space.400'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AIOptionsMenuWrapper = styled.div({
	display: 'flex',
	paddingTop: token('space.200'),
	paddingBottom: token('space.200'),
	gap: token('space.250'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AIOptionsMenuOptionWrapper = styled.div({
	paddingLeft: token('space.150'),
	paddingRight: token('space.075'),
	width: '320px',
	display: 'flex',
	flexDirection: 'row',
	gap: token('space.250'),
	justifyContent: 'space-between',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AIOptionsMenuOptionText = styled.div({
	display: 'flex',
	flexDirection: 'column',
	gap: token('space.050'),
	width: '244px',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AIOptionsMenuOptionHeader = styled.div({
	font: token('font.body'),
	color: token('color.text'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AIOptionsMenuOptionDescription = styled.div({
	font: token('font.body.small'),
	color: token('color.text.subtlest'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const AIOptionsMenuOptionToggleWrapper = styled.div({
	display: 'flex',
	width: 'fit-content',
});
